import { Model } from "vue-mc";

export class Se extends Model {
  defaults() {
    return {
      clave: null
      , se: ""
      , seller: ""
      , storeid: ""
      , negocio: "PROP"
      , nombre: ""
      , razonsocial: ""
      , cuit: ""
      , direccion: ""
      , altura: ""
      , provincia: null
      , localidad: null
      , referencia: ""
      , codigopostal: ""
      , email: ""
      , telefono: ""
      , acuerdo: null
      , subindustria: null
      , partner: null
      , latitud: ""
      , longitud: ""
      , grupocontrol: false
      , geoRelevancia: null
      , photos: null
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , se: (se) => se
      , seller: (seller) => seller
      , storeid: (storeid) => storeid
      , negocio: (negocio) => negocio
      , nombre: (nombre) => nombre
      , razonsocial: (razonsocial) => razonsocial
      , cuit: (cuit) => cuit
      , direccion: (direccion) => direccion
      , altura: (altura) => altura
      , provincia: (provincia) => provincia
      , localidad: (localidad) => localidad
      , referencia: (referencia) => referencia
      , codigopostal: (codigopostal) => codigopostal
      , telefono: (telefono) => telefono
      , acuerdo: (acuerdo) => acuerdo
      , subindustria: (subindustria) => subindustria
      , partner: (partner) => partner
      , latitud: (latitud) => latitud
      , longitud: (longitud) => longitud
      , grupocontrol: (grupocontrol) => grupocontrol
      , geoRelevancia: (geoRelevancia) => geoRelevancia
      , photos: (photos) => photos
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/se.js